var $682989befd4f478d$exports = {};
$682989befd4f478d$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " \u063A\u064A\u0631 \u0627\u0644\u0645\u062D\u062F\u062F");
  },
  "longPressToSelect": "\u0627\u0636\u063A\u0637 \u0645\u0637\u0648\u0644\u064B\u0627 \u0644\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u0648\u0636\u0639 \u0627\u0644\u062A\u062D\u062F\u064A\u062F.",
  "select": "\u062A\u062D\u062F\u064A\u062F",
  "selectedAll": "\u062C\u0645\u064A\u0639 \u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u062D\u062F\u062F\u0629.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "\u0644\u0645 \u064A\u062A\u0645 \u062A\u062D\u062F\u064A\u062F \u0639\u0646\u0627\u0635\u0631",
      one: function one() {
        return "".concat(formatter.number(args.count), " \u0639\u0646\u0635\u0631 \u0645\u062D\u062F\u062F");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \u0639\u0646\u0635\u0631 \u0645\u062D\u062F\u062F");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " \u0627\u0644\u0645\u062D\u062F\u062F");
  }
};
export { $682989befd4f478d$exports as default };